var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "div",
        { staticClass: "pl-20 pr-20 pb-20 bg-white" },
        [
          _c(
            "el-row",
            { staticClass: "fs-s4" },
            [
              _c(
                "el-col",
                { attrs: { xs: { span: 24 }, sm: { span: 12 } } },
                [
                  _c("h4", { staticClass: "mb-10" }, [
                    _vm._v(
                      "订单状态（" + _vm._s(_vm.info.order_status_des) + "）"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.info.remark))]),
                  _vm._v(" "),
                  _c("h4", { staticClass: "mb-10" }, [_vm._v("订单信息")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-10" }, [
                    _vm._v("订单号：" + _vm._s(_vm.info.order_sn)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-10" }, [
                    _vm._v("用户昵称：" + _vm._s(_vm.info.user_nick_name)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-10" }, [
                    _vm._v("用户ID：" + _vm._s(_vm.info.uid)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-10" }, [
                    _vm._v("手机号码：" + _vm._s(_vm.info.user_mobile)),
                  ]),
                  _vm._v(" "),
                  _vm.info.depend_type == 0
                    ? [
                        _c("div", { staticClass: "mb-10" }, [
                          _vm._v("租借时间：" + _vm._s(_vm.info.charge_start)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-10" }, [
                          _vm._v(
                            "租借商户：" + _vm._s(_vm.info.rent_address || "--")
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-10" }, [
                          _vm._v(
                            "归还时间：" + _vm._s(_vm.info.charge_end || "--")
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-10" }, [
                          _vm._v(
                            "归还商户：" + _vm._s(_vm.info.back_address || "--")
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-10" }, [
                          _vm._v("设备SN码：" + _vm._s(_vm.info.goods_sn)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-10" }, [
                          _vm._v(
                            "押金类型：" +
                              _vm._s(_vm.info.pay_type == 2 ? "免押" : "押金")
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-10" }, [
                          _vm._v(
                            "押金状态：" + _vm._s(_vm.info.deposit_status)
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.info.out_order_no
                          ? _c("div", { staticClass: "mb-10" }, [
                              _vm._v(
                                "免押单号：" + _vm._s(_vm.info.out_order_no)
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.info.transaction_id
                          ? _c("div", { staticClass: "mb-10" }, [
                              _vm._v(
                                "交易单号：" + _vm._s(_vm.info.transaction_id)
                              ),
                            ])
                          : _vm._e(),
                      ]
                    : [
                        _c("div", { staticClass: "mb-10" }, [
                          _vm._v("开始时间：" + _vm._s(_vm.info.charge_start)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-10" }, [
                          _vm._v(
                            "结束时间：" + _vm._s(_vm.info.charge_end || "--")
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-10" }, [
                          _vm._v("设备SN码：" + _vm._s(_vm.info.goods_sn)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-10" }, [
                          _vm._v(
                            "套餐类型：" + _vm._s(_vm.xiyiji_fee_plan.name)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-10" }, [
                          _vm._v(
                            "支付方式：" + _vm._s(_vm.info.deposit_status)
                          ),
                        ]),
                      ],
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex align-center" },
                    [
                      _c("div", { staticClass: "flex1" }, [
                        _vm._v("实付金额：￥" + _vm._s(_vm.info.money_paid)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", plain: "", size: "small" },
                          on: {
                            click: function ($event) {
                              _vm.detailDialog = true
                            },
                          },
                        },
                        [_vm._v("流转记录")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { xs: { span: 24 }, sm: { span: 12 } } },
                [
                  _vm.washRefund.refund_status > 0
                    ? [
                        _c("h4", { staticClass: "mb-10" }, [
                          _vm._v("退款详情"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-10" }, [
                          _vm._v(
                            "退款状态：" +
                              _vm._s(
                                _vm.refundStatus[_vm.washRefund.refund_status]
                              )
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.washRefund.refuse_reason
                          ? _c("div", { staticClass: "mb-10" }, [
                              _vm._v(
                                "拒绝原因：" + _vm._s(_vm.info.refuse_reason)
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-10" }, [
                          _vm._v(
                            "退款金额：" +
                              _vm._s(_vm.washRefund.refund_money) +
                              "元"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-10" }, [
                          _vm._v("手机号码：" + _vm._s(_vm.washRefund.mobile)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-10" }, [
                          _vm._v(
                            "问题描述：" + _vm._s(_vm.washRefund.refund_reason)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "flex" }, [
                          _c("div", [_vm._v("错误截图：")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex1" },
                            _vm._l(
                              _vm.washRefund.refund_img_url,
                              function (item) {
                                return _c("el-image", {
                                  staticClass: "mr-5",
                                  staticStyle: {
                                    width: "50px",
                                    height: "50px",
                                  },
                                  attrs: {
                                    src: item,
                                    "preview-src-list":
                                      _vm.washRefund.refund_img_url,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ]),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.info.agents_profit.length != 0
                    ? [
                        _c("h4", { staticClass: "mb-10" }, [
                          _vm._v(
                            "分成明细（" + _vm._s(_vm.info.money_paid) + ")"
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.info.agents_profit, function (item) {
                          return _c("div", { staticClass: "mb-10 flex" }, [
                            _c("div", { staticClass: "flex1" }, [
                              _vm._v(
                                _vm._s(item.agent_name) +
                                  "：" +
                                  _vm._s(item.parent_name)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex1" }, [
                              _vm._v(
                                _vm._s(item.get_profit) +
                                  "元（" +
                                  _vm._s(item.profit_percent) +
                                  "）"
                              ),
                            ]),
                          ])
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "流转记录", visible: _vm.detailDialog },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialog = $event
            },
          },
        },
        [
          _c(
            "el-timeline",
            _vm._l(_vm.flow, function (item, index) {
              return _c(
                "el-timeline-item",
                {
                  key: index,
                  attrs: { placement: "top", timestamp: item.date },
                },
                [
                  _c("div", [
                    _vm._v(_vm._s(item.event) + " ---> " + _vm._s(item.result)),
                  ]),
                  _vm._v(" "),
                  item.reason
                    ? _c(
                        "div",
                        { staticClass: "mt-5" },
                        [
                          _c("el-link", { attrs: { type: "danger" } }, [
                            _vm._v(_vm._s(item.reason)),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }